import { Component, ChangeDetectionStrategy } from '@angular/core';

import { ModalState, ModalSettingsChangePassword } from './generic-modal.service';

@Component({
    selector: 'ep-modal-change-password',
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './modal-change-password.component.html'
})
export class ModalChangePasswordComponent {
    options: ModalSettingsChangePassword;

    constructor(private modalState: ModalState) {
        this.options = modalState.options as ModalSettingsChangePassword;
    }

    close() {
        this.modalState.modal.dismiss();
    }

    ok(password: string) {
        this.modalState.modal.close(password);
    }
}